import { DataType } from "../../GlobalConstants"

export const TableView = ({ data, columns }) => {

    return (
        <table className="table table-md table-pin-rows table-pin-cols">
            <thead>
                <tr>
                    {
                        columns.map(({ name, field, type }) =>
                            type === DataType.ACTION ?
                                <th key={name}></th> :
                                <th className="text-base" key={field} aria-label={field} >{name}</th>
                        )
                    }
                </tr>
            </thead>
            <tbody>
                {
                    data && data.length ? data.map((rowData, rowIndex) => (
                        <tr key={rowIndex} className="cursor-pointer transition-all duration-200 group hover:shadow-md hover:bg-accent">
                            {
                                columns.map(({ name, field, type, children }) =>
                                    type === DataType.ACTION ?
                                        <td key={`row-${rowIndex}-${name}`}>
                                            {children && typeof children === "function" && children(rowData)}
                                        </td>
                                        :
                                        <td key={`row-${rowIndex}-${field}`} aria-label={`row-${rowIndex}-${field}`}>
                                            {rowData[field] ?

                                                //If date type Data
                                                type === DataType.DATE ? new Date(rowData[field]).toLocaleDateString() :
                                                    rowData[field]
                                                :

                                                ''}
                                        </td>
                                )
                            }

                        </tr>
                    ))
                        :

                        <tr>No Records Found</tr>
                }

            </tbody>
        </table>
    )
}